import React, { Component } from "react";

import styles from "./cmsConnectorSensorTools.module.scss";
import { withCurrentDevices } from "../../../shared/containers/containerCurrentDevice";
import { withDevices } from "../../../shared/containers/containerDevices";
import { withListSensors } from "../../../shared/containers/containerListSensors";
import ButtonPrimary from "../../../shared/items/contols/buttonPrimary";
import { FormControl, MenuItem, Select, TextField } from "@mui/material";
import { states } from "../../../reducers/queriesStates";
import Preloader from "../../../shared/items/static/preloader";

class CmsConnectorSensorCreateForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      errors: [],
      deviceInput: null,
      protocolMarkers: null,
      connectedSensor: this.emptyConnectedSensor(),
    };
  }

  emptyConnectedSensor() {
    return {
      deviceId: this.props.currentDevice.id,
      sensorId: null,
      deviceInPut: {
        marker: null,
        divider: null,
        mask: null,
        term: null,
        separatedItem: null,
      },
    };
  }

  componentDidMount() {
    const { dataStateProtocolMarkers, onGetProtocolMarkers } = this.props;

    if (dataStateProtocolMarkers === states.NOT_REQUESTED) {
      onGetProtocolMarkers();
    }
  }

  componentDidUpdate(prevProps) {
    const { errors, createConnectedSensorDataState } = this.props;

    if (createConnectedSensorDataState === states.FAILURE && prevProps.createConnectedSensorDataState === states.REQUEST) {
      this.setState({ errors });
    }

    if (createConnectedSensorDataState === states.READY && prevProps.createConnectedSensorDataState === states.REQUEST) {
      this.setState({ connectedSensor: this.emptyConnectedSensor() });
    }
  }

  onSelectSensor(e) {
    const { connectedSensor } = this.state;
    connectedSensor.sensorId = e.target.value;
    this.setState({ connectedSensor });
  }

  onSelectMarker(e) {
    const { connectedSensor } = this.state;
    connectedSensor.deviceInPut.marker = e.target.value;
    this.setState({ connectedSensor });
  }

  onChangeDivider(e) {
    const { connectedSensor } = this.state;
    connectedSensor.deviceInPut.divider = e.target.value;
    this.setState({ connectedSensor });
  }

  onChangeMask(e) {
    const { connectedSensor } = this.state;
    connectedSensor.deviceInPut.mask = e.target.value;
    this.setState({ connectedSensor });
  }

  onChangeTerm(e) {
    const { connectedSensor } = this.state;
    connectedSensor.deviceInPut.term = e.target.value;
    this.setState({ connectedSensor });
  }

  onChangeSeparatedItem(e) {
    const { connectedSensor } = this.state;
    connectedSensor.deviceInPut.separatedItem = e.target.value;
    this.setState({ connectedSensor });
  }

  onChangeTitle(e) {
    const { connectedSensor } = this.state;
    connectedSensor.deviceInPut.title = e.target.value;
    this.setState({ connectedSensor });
  }

  buttonDisable() {
    const { connectedSensor } = this.state;

    const isNullOrEmpty = (value) => {
      return value === null || value === "";
    };

    return isNullOrEmpty(connectedSensor.sensorId) || isNullOrEmpty(connectedSensor.deviceInPut.marker);
  }

  onAddConnectedSensorHandler() {
    const { onCreateConnectedSensor } = this.props;
    const { connectedSensor } = this.state;

    onCreateConnectedSensor(connectedSensor);
    this.setState({ errors: [] });
  }

  render() {
    const { listSensors, currentDevice, protocolMarkers, createConnectedSensorDataState } = this.props;
    const { connectedSensor, errors } = this.state;

    return (
      <div>
        <div className={styles.cmsCreateErrorContainer}>
          {errors.map((error, index) => {
            return <div key={index}>{error}</div>;
          })}
        </div>
        <div className={styles.cmsCreateForm}>
          <div>
            <FormControl variant="standard" sx={{ m: 1, display: "inline-block" }}>
              <div>Датчик:</div>
              <Select
                style={{ width: "200px" }}
                onChange={this.onSelectSensor.bind(this)}
                value={connectedSensor.sensorId === null ? "" : connectedSensor.sensorId}
              >
                <MenuItem value={connectedSensor.sensorId}>{"- - - "}</MenuItem>
                {listSensors.sensors
                  .filter((x) => {
                    return !currentDevice.connectedSensors.some((cs) => {
                      return cs.sensor.id === x.id;
                    });
                  })
                  .map((sensor) => {
                    return (
                      <MenuItem key={sensor.id} value={sensor.id} style={{ display: "block", padding: "3px" }}>
                        {sensor.title}
                      </MenuItem>
                    );
                  })}
              </Select>
            </FormControl>
          </div>

          <div>
            <FormControl variant="standard" sx={{ m: 1, display: "inline-block" }}>
              <div>Маркер входа:</div>
              <Select
                style={{ width: "200px" }}
                onChange={this.onSelectMarker.bind(this)}
                value={connectedSensor.deviceInPut.marker === null ? "" : connectedSensor.deviceInPut.marker}
              >
                {protocolMarkers.protocolMarkers
                  .filter((x) => {
                    return x.value === currentDevice.type;
                  })[0]
                  .markers.map((marker) => {
                    return (
                      <MenuItem key={marker.value} value={marker.value} style={{ display: "block", padding: "3px" }}>
                        <b>{marker.code}:</b> {marker.title}
                      </MenuItem>
                    );
                  })}
              </Select>
            </FormControl>
          </div>

          <div className={styles.cmsConnectorSensorField}>
            <TextField
              disabled={connectedSensor.sensorId === null}
              value={connectedSensor.deviceInPut.divider === null ? "" : connectedSensor.deviceInPut.divider}
              id="outlined-basic"
              label="Делитель"
              variant="outlined"
              size="small"
              type="number"
              onChange={this.onChangeDivider.bind(this)}
            />
          </div>

          <div className={styles.cmsConnectorSensorField}>
            <TextField
              disabled={connectedSensor.sensorId === null}
              value={connectedSensor.deviceInPut.mask === null ? "" : connectedSensor.deviceInPut.mask}
              id="outlined-basic"
              label="Маска"
              variant="outlined"
              size="small"
              type="number"
              onChange={this.onChangeMask.bind(this)}
            />
          </div>

          <div className={styles.cmsConnectorSensorField}>
            <TextField
              disabled={connectedSensor.sensorId === null}
              value={connectedSensor.deviceInPut.term === null ? "" : connectedSensor.deviceInPut.term}
              id="outlined-basic"
              label="Смещение"
              variant="outlined"
              size="small"
              type="number"
              onChange={this.onChangeTerm.bind(this)}
            />
          </div>

          <div className={styles.cmsConnectorSensorField}>
            <TextField
              disabled={connectedSensor.sensorId === null}
              value={connectedSensor.deviceInPut.separatedItem === null ? "" : connectedSensor.deviceInPut.separatedItem}
              id="outlined-basic"
              label="№ Элемента"
              variant="outlined"
              size="small"
              type="number"
              onChange={this.onChangeSeparatedItem.bind(this)}
            />
          </div>

          <div className={styles.cmsConnectorSensorAddButton}>
            {createConnectedSensorDataState === states.REQUEST ? (
              <div style={{ display: "flex", justifyContent: "center" }}>
                <Preloader />
              </div>
            ) : (
              <ButtonPrimary disabled={this.buttonDisable()} handleClick={this.onAddConnectedSensorHandler.bind(this)} title="Подключить" />
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default withCurrentDevices(withDevices(withListSensors(CmsConnectorSensorCreateForm)));
